var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Cancel01Icon, SearchAddIcon, SearchMinusIcon } from 'hugeicons-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Highlight, PdfHighlighter, PdfLoader } from 'react-pdf-highlighter';
import 'react-pdf-highlighter/dist/style.css';
import translationSupportedLanguages from '../../../../../../../application/common/constants/translation-supported-languages';
import { useLazyGetMachineDocumentQuery } from '../../../../../../../application/features/machine-documents/machine-document-api';
import { graphApi } from '../../../../../../../application/features/microsoft-graph/microsoft-graph-api';
import { useDetectLanguageMutation, useTranslateTextMutation } from '../../../../../../../application/features/microsoft-translation/microsoft-translation-api';
import useTranslate from '../../../../../../../localization/helpers';
import PdfIcon from '../../../../../../icons/components/pdf-icon';
import PdfIconDisabled from '../../../../../../icons/components/pdf-icon-disabled';
import './style.scss';
import TranslateSelection from './TranslateSelection';
var FileViewerDialog = function (_a) {
    var sources = _a.sources, source = _a.source, doc_content = _a.doc_content, hash_id = _a.hash_id, message_id = _a.message_id, isFetching = _a.isFetching, sourceDocument = _a.sourceDocument, document_name = _a.document_name, scroll_id = _a.scroll_id, onClose = _a.onClose, OnTranslatedTextSelection = _a.OnTranslatedTextSelection, isActualChat = _a.isActualChat, isExpanded = _a.isExpanded, setIsExpanded = _a.setIsExpanded, toggleExpanded = _a.toggleExpanded;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var _b = __read(useDetectLanguageMutation(), 1), detectLanguageMutation = _b[0];
    var _c = __read(useTranslateTextMutation(), 1), translateTextMutation = _c[0];
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var _d = __read(useState(''), 2), previewUrl = _d[0], setPreviewUrl = _d[1];
    var _e = __read(useState(''), 2), previousMessageId = _e[0], setPreviousMessageId = _e[1];
    var _f = __read(useState(''), 2), previousDocumentName = _f[0], setPreviousDocumentName = _f[1];
    var _g = __read(useState([]), 2), highlights = _g[0], setHighlights = _g[1];
    var _h = __read(useState([]), 2), sourcesData = _h[0], setSourcesData = _h[1];
    var isIpad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
    var _j = __read(useState([]), 2), dropdownOptions = _j[0], setDropdownOptions = _j[1];
    var _k = __read(useLazyGetMachineDocumentQuery(), 2), triggerGetDocument = _k[0], chatDocument = _k[1].data;
    var _l = __read(useState(1.0), 2), scale = _l[0], setScale = _l[1];
    var handleClose = function () {
        setIsExpanded(false);
        onClose();
    };
    var handleZoomIn = function () {
        setScale(function (prev) { return Math.min(prev + 0.2, 3.0); });
    };
    var handleZoomOut = function () {
        setScale(function (prev) { return Math.max(prev - 0.2, 1.0); });
    };
    useEffect(function () {
        if (isFetching) {
            setHighlights([]);
        }
        else {
            if (source && previousDocumentName !== source.document) {
                fetchPreviewUrl(source.filepath);
                setPreviousDocumentName(source.document);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source, isFetching]);
    useEffect(function () {
        var _a, _b, _c;
        if (scroll_id) {
            setHighlights(highlightData);
            handleTextSelection((_c = (_b = (_a = highlightData[0]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : '');
            document.location.hash = "highlight-".concat(hash_id);
            var highlight_1 = getHighlightById(parseIdFromHash());
            if (highlight_1) {
                if (previousMessageId !== message_id) {
                    setTimeout(function () {
                        scrollViewerTo.current(highlight_1);
                    }, 3500);
                }
                else {
                    if (previousDocumentName !== document_name) {
                        setTimeout(function () {
                            scrollViewerTo.current(highlight_1);
                        }, 3500);
                    }
                    else {
                        setTimeout(function () {
                            scrollViewerTo.current(highlight_1);
                        }, 500);
                    }
                }
                setPreviousMessageId(message_id);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scroll_id]);
    useEffect(function () {
        if (sourceDocument)
            triggerGetDocument(sourceDocument.document_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sourceDocument]);
    var fetchPreviewUrl = useCallback(function (filePath) { return __awaiter(void 0, void 0, void 0, function () {
        var previewUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setHighlights([]);
                    return [4 /*yield*/, graphApi.getDownloadUrl(filePath)];
                case 1:
                    previewUrl = _a.sent();
                    setPreviewUrl(previewUrl);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var scrollToHighlightFromHash = useCallback(function () {
        var highlight = getHighlightById(parseIdFromHash());
        if (highlight) {
            var target = document.getElementById("highlight-".concat(hash_id));
            if (target && target.offsetParent) {
                scrollViewerTo.current(highlight);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var detectLanguage = function (text) { return __awaiter(void 0, void 0, void 0, function () {
        var language;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (text === '')
                        return [2 /*return*/];
                    return [4 /*yield*/, detectLanguageMutation({ text: text }).unwrap()];
                case 1:
                    language = _a.sent();
                    return [2 /*return*/, language];
            }
        });
    }); };
    var handleTextSelection = function (selectedText) { return __awaiter(void 0, void 0, void 0, function () {
        var detectedLang_1, options, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, detectLanguage(selectedText)];
                case 1:
                    detectedLang_1 = _b.sent();
                    options = Object.keys(translationSupportedLanguages)
                        .filter(function (lang) { return lang !== detectedLang_1; })
                        .map(function (lang) {
                        return "".concat(translate('common.translateTo'), " ").concat(translationSupportedLanguages[lang]);
                    });
                    setDropdownOptions(options);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setDropdownOptions(Object.keys(translationSupportedLanguages).map(function (lang) { return "".concat(translate('common.translateTo'), " ").concat(translationSupportedLanguages[lang]); }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var formatSelectedText = function () {
        var selection = window.getSelection();
        if (!selection || selection.rangeCount === 0)
            return '';
        var selectedText = '';
        for (var i = 0; i < selection.rangeCount; i++) {
            var range = selection.getRangeAt(i);
            selectedText += range.cloneContents().textContent + ' ';
        }
        selectedText = selectedText
            .replace(/(\.)(\s*)(\d+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([a-zA-Z]\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([IVXLCDM]+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)(-)/g, '$1\n$3')
            .replace(/(\.)(\s*)(•)/g, '$1\n$3')
            .replace(/\n+/g, '\n');
        return selectedText.trim();
    };
    var translateText = function (text, targetLanguage, button) { return __awaiter(void 0, void 0, void 0, function () {
        var previousButtonDisplay, parentElement, previousParentDisplay, formatedText, textToTranslate, translatedText, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    previousButtonDisplay = button.style.display;
                    button.style.display = 'none';
                    parentElement = button.closest('.translate-component');
                    previousParentDisplay = parentElement === null || parentElement === void 0 ? void 0 : parentElement.style.display;
                    if (parentElement)
                        parentElement.style.display = 'none';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (text === '')
                        return [2 /*return*/];
                    formatedText = formatSelectedText();
                    textToTranslate = formatedText || text;
                    return [4 /*yield*/, translateTextMutation({
                            text: textToTranslate,
                            targetLanguage: targetLanguage
                        }).unwrap()];
                case 2:
                    translatedText = _b.sent();
                    OnTranslatedTextSelection(translatedText !== null && translatedText !== void 0 ? translatedText : '');
                    if (isXs || isIpad) {
                        onClose();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    button.style.display = previousButtonDisplay;
                    if (parentElement)
                        parentElement.style.display = previousParentDisplay !== null && previousParentDisplay !== void 0 ? previousParentDisplay : '';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        window.addEventListener('hashchange', scrollToHighlightFromHash, false);
        return function () {
            window.removeEventListener('hashchange', scrollToHighlightFromHash, false);
        };
    }, [scrollToHighlightFromHash]);
    var scrollViewerTo = useRef(function (highlight) {
        // Implement scrolling logic here
    });
    var getUniqueSources = function (sources) {
        var uniqueSources = Array.from(new Map(sources.map(function (source) { return [source.document, source]; })).values());
        return uniqueSources;
    };
    var uniqueSources = getUniqueSources(sourcesData);
    var getHighlightById = function (id) {
        return highlightData.find(function (highlight) { return highlight.id === id; });
    };
    var mapApiResponsesToIHighlights = function (doc_contents, sources) {
        var highlights = [];
        doc_contents.forEach(function (doc) {
            var bbox = doc.bbox, content = doc.content;
            if (bbox.length === 0)
                return;
            var source = sources.find(function (src) { return src.document === doc.document; });
            var defaultDimensions = { width: 595.2760009765625, height: 841.8900146484375 };
            var dimensions = source
                ? { width: source.width, height: source.height }
                : defaultDimensions;
            var rects = bbox.map(function (rect) { return ({
                x1: rect.x1,
                y1: rect.y1,
                x2: rect.x2,
                y2: rect.y2,
                width: dimensions.width,
                height: dimensions.height
            }); });
            var boundingRect = {
                x1: Math.min.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.x1; })), false)),
                y1: Math.min.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.y1; })), false)),
                x2: Math.max.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.x2; })), false)),
                y2: Math.max.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.y2; })), false)),
                width: Math.max.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.width; })), false)),
                height: Math.max.apply(Math, __spreadArray([], __read(rects.map(function (rect) { return rect.height; })), false))
            };
            var highlight = {
                id: doc.doc_content_id,
                content: { text: content },
                position: {
                    boundingRect: boundingRect,
                    rects: rects,
                    pageNumber: doc.page
                },
                comment: {
                    emoji: '',
                    text: ''
                }
            };
            highlights.push(highlight);
        });
        return highlights;
    };
    // Use the function
    var highlightData = mapApiResponsesToIHighlights(doc_content, sources);
    var parseIdFromHash = function () { return document.location.hash.slice('#highlight-'.length); };
    var resetHash = function () {
        document.location.hash = '';
    };
    var handleLanguageSelect = function (langCode) {
        var langLabel = langCode.replace("".concat(translate('common.translateTo'), " "), '');
        var langEntry = Object.entries(translationSupportedLanguages).find(function (_a) {
            var _b = __read(_a, 2), code = _b[0], label = _b[1];
            return label === langLabel;
        });
        var langCodeKey = langEntry ? langEntry[0] : '';
        return langCodeKey;
    };
    useEffect(function () {
        setSourcesData(sources);
    }, [sources]);
    return (_jsxs(Box, { width: '100%', height: '100%', flexDirection: 'column', children: [_jsx(Box, { sx: { padding: '8px 20px' }, children: isXs || isIpad ? (_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '12px', children: [_jsx(Typography, { variant: 'h6', children: chatDocument === null || chatDocument === void 0 ? void 0 : chatDocument.title }), _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(IconButton, { onClick: handleZoomOut, disabled: scale <= 1.0, children: _jsx(ZoomOut, { fontSize: 'small' }) }), _jsxs(Typography, { variant: 'body2', children: [Math.round(scale * 100), "%"] }), _jsx(IconButton, { onClick: handleZoomIn, disabled: scale >= 3.0, children: _jsx(ZoomIn, { fontSize: 'small' }) }), _jsx(IconButton, { onClick: onClose, children: _jsx(Cancel01Icon, {}) })] })] })) : (_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '12px', children: [_jsx(Typography, { variant: 'h6', children: chatDocument === null || chatDocument === void 0 ? void 0 : chatDocument.title }), _jsxs(Box, { display: 'flex', children: [_jsx(IconButton, { size: 'medium', sx: { border: "1px solid ".concat(theme.palette.divider) }, onClick: toggleExpanded, children: isExpanded ? _jsx(SearchMinusIcon, {}) : _jsx(SearchAddIcon, {}) }), _jsx(IconButton, { onClick: function () { return handleClose(); }, children: _jsx(Cancel01Icon, {}) })] })] })) }), _jsxs(Box, { gap: 0, padding: !isXs && !isIpad ? '0px 0px 0px 20px' : '0px 20px 0px 20px', display: 'flex', flexDirection: !isXs && !isIpad ? 'row' : 'column', justifyContent: 'center', alignItems: isXs || isIpad ? 'center' : 'flex-start', height: !isXs && !isIpad ? 'calc(100svh - 232px)' : '90%', children: [(isXs || isIpad) && (_jsx(Box, { maxWidth: '100%', mb: 1, children: _jsx(Box, { maxWidth: '100%', display: 'flex', flexDirection: 'row', borderRadius: 2, bgcolor: 'white', zIndex: 10000, gap: 1, boxShadow: theme.customShadows.z8, sx: { overflowX: 'auto' }, children: uniqueSources.map(function (source, index) { return (_jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 0.5, padding: '8px', sx: {
                                    cursor: 'pointer',
                                    opacity: previousDocumentName === source.document ? 1 : 0.7,
                                    transition: 'opacity 0.3s, background-color 0.3s'
                                }, onClick: function () { return setPreviousDocumentName(source.document); }, children: [_jsx(Box, { display: 'flex', alignItems: 'center', padding: '4px', bgcolor: previousDocumentName === source.document ? '#F4F6F8' : 'transparent', borderRadius: 1, children: previousDocumentName === source.document ? _jsx(PdfIcon, {}) : _jsx(PdfIconDisabled, {}) }), _jsx(Typography, { maxWidth: '52px', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center', fontSize: 10, whiteSpace: 'nowrap', children: source.document })] }, index)); }) }) })), _jsx(Box, { sx: {
                            width: !isXs && !isIpad ? '90%' : '100%',
                            height: '100%',
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            borderTopRightRadius: 0,
                            overflow: 'auto',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative',
                            zIndex: 999,
                            touchAction: 'none',
                            '& .pdfViewer': {}
                        }, children: previewUrl ? (_jsx(PdfLoader, { url: previewUrl, beforeLoad: _jsxs(Typography, { children: [translate('chat.loadingPDF'), "..."] }), children: function (pdfDocument) { return (_jsx(Box, { position: 'absolute', height: '100%', width: '100%', onContextMenu: function (e) { return e.preventDefault(); }, sx: {
                                    overflowX: 'hidden',
                                    transform: "scale(".concat(scale, ")"),
                                    transformOrigin: '0 0'
                                }, children: _jsx(PdfHighlighter, { pdfScaleValue: 'page-width', pdfDocument: pdfDocument, onScrollChange: resetHash, scrollRef: function (scrollTo) {
                                        scrollViewerTo.current = scrollTo;
                                        scrollToHighlightFromHash();
                                    }, onSelectionFinished: function (_, content) {
                                        var _a;
                                        if (!isActualChat)
                                            return null;
                                        var selectedContent = (_a = content.text) !== null && _a !== void 0 ? _a : '';
                                        handleTextSelection(selectedContent);
                                        return (_jsx(TranslateSelection, { selectedContent: selectedContent, dropdownOptions: dropdownOptions, handleLanguageSelect: handleLanguageSelect, translateText: translateText }));
                                    }, enableAreaSelection: function (event) { return event.altKey; }, highlightTransform: function (highlight, index, setTip, hideTip, viewportToScaled, screenshot, isScrolledTo) {
                                        return (_jsx(Highlight, { isScrolledTo: isScrolledTo, position: highlight.position, comment: { emoji: '', text: '' }, onMouseOver: function () {
                                                var _a;
                                                if (!isActualChat)
                                                    return;
                                                var selectedContent = (_a = highlight.content.text) !== null && _a !== void 0 ? _a : '';
                                                handleTextSelection(selectedContent);
                                                setTip(highlight, function () { return (_jsx(TranslateSelection, { selectedContent: selectedContent, dropdownOptions: dropdownOptions, handleLanguageSelect: handleLanguageSelect, translateText: translateText })); });
                                            } }, index));
                                    }, highlights: highlights }) })); } })) : (_jsxs(Typography, { variant: 'body1', children: [translate('chat.loadingPDF'), "..."] })) }), _jsx(Box, { display: 'flex', maxHeight: '100%', pb: 4, overflow: 'auto', flexDirection: 'column', position: 'relative', children: !isXs &&
                            !isIpad &&
                            uniqueSources.map(function (source, index) { return (_jsx(Box, { width: '100%', className: 'document-viewer', boxShadow: previousDocumentName === source.document ? theme.customShadows.z8 : undefined, borderRadius: '0px 16px 16px 0px', zIndex: previousDocumentName === source.document ? 1100 : 1000, children: _jsx(Box, { maxHeight: '676px', display: 'flex', flexDirection: 'column', padding: '0px 8px', sx: { overflowY: 'auto' }, zIndex: 1000, borderRadius: '0px 16px 16px 0px', bgcolor: 'white', gap: '20px', children: _jsxs(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5, padding: '8px', sx: {
                                            cursor: 'pointer',
                                            opacity: previousDocumentName === source.document ? 1 : 0.7,
                                            transition: 'opacity 0.3s, background-color 0.3s'
                                        }, onClick: function () { return setPreviousDocumentName(source.document); }, children: [_jsx(Box, { display: 'flex', alignItems: 'center', padding: '4px', bgcolor: previousDocumentName === source.document ? '#F4F6F8' : 'transparent', borderRadius: 1, children: previousDocumentName === source.document ? _jsx(PdfIcon, {}) : _jsx(PdfIconDisabled, {}) }), _jsx(Typography, { maxWidth: '52px', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center', fontSize: 10, whiteSpace: 'nowrap', children: isFetching ? previousDocumentName : source.document })] }) }) }, index)); }) })] })] }));
};
export default FileViewerDialog;
